/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path apihooks
 * @description Ranges hook
 */
/// import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';
import axios, { AxiosError, AxiosResponse } from "axios";
import { useAppContext } from "./../context/AppCtxProvider";
import { useQuery } from "react-query";
import { isValidId } from "./../utils/url-utils";
export interface Range {
  name: string;
  maxseriesid: string;
  maxbelongstorange: string;
  minseriesid: string;
  minbelongstorange: string;
  rangevalue: string | undefined;
  color: string;
  disabled?: boolean;
}
export const useRanges = (
  meaId: string | undefined,
  recursive: boolean = false,
  recursionCount: number,
  criteria: string = ""
) => {
  const ctx = useAppContext();
  return useQuery<AxiosResponse<Range[]>, AxiosError<any>>(
    `ranges-${meaId}-${criteria}`,
    async () => {
      const normalizedCriteria = criteria
        ? criteria.replace(/\\"/g, '"')
        : "";
      const recursiveDepth = recursive ? recursionCount || 1 : 0;
      const response = await axios.post("meaquery", {
        query: `[${meaId}].childobjects(recursive=${recursiveDepth}, keepOriginals=1${
          normalizedCriteria ? `, criteria=${JSON.stringify(normalizedCriteria)}` : ""
        }).attributeasfunction(attributeasfunction="valuesettingid").ranges`,
        attributes: `name, maxseriesid, maxbelongstorange, minseriesid, minbelongstorange, rangevalue(period="${ctx.period}"), color, valuesettings`,
        sortBy: "rangeValue",
      });
      return response.data;
    },
    {
      enabled: !!meaId && isValidId(meaId),
      staleTime: 60 * 1000,
    }
  );
};
